<template lang="pug">
  .columns.is-vcentered
    .column.is-3-desktop
    .login.column.is-6
      section.section
        img.login-logo(:src="ecoinventLogo")
        .content
          h3 {{ $t('Data Converter Password Reset') }}
        form(@submit.prevent="resetPassword")
          b-field(
          :label="$t('E-Mail')"
          :message="errors.email"
          :type="{'is-danger': !!errors.email}"
          )
            b-input(type="email" v-model="email" @input="$set(errors, 'email', null)" disabled)
          b-field(
          :label="$t('New Password')"
          :message="errors['password']"
          :type="{'is-danger': !!errors.password}"
          )
            b-input(type="password" v-model="password" icon="key" @input="$set(errors, 'password', null)")
          b-field(
          :label="$t('Repeat new Password')"
          :message="errors['password2']"
          :type="{'is-danger': !!errors.password2}"
          )
            b-input(type="password" v-model="password2" icon="key" @input="$set(errors, 'password2', null)")
          .has-text-centered
            input.button.is-vcentered.is-primary.is-outlined(
            type="submit" :value="$t('Set new Password')" :disabled="submitting"
            )
    .column.is-3-desktop
</template>

<script>
import { resetPassword } from '../utils/api'

export default {
  name: 'Register',
  data() {
    return {
      email: '',
      token: '',
      password: '',
      password2: '',
      errors: {},
      submitting: false,
      ecoinventLogo: require('../assets/ecoinvent Brand mark.png')
    }
  },
  mounted() {
    this.token = this.$route.params.token
    this.email = this.$route.params.email
  },
  methods: {
    resetPassword() {
      if (this.submitting) {
        return
      }
      if (this.password !== this.password2) {
        this.errors.password2 = this.$t('The passwords you entered do not match.')
      } else {
        this.submitting = true
        resetPassword(this.email, this.token, this.password)
          .then(() => {
            this.$toast.open({
              message: this.$t('Your password was successfully reset.'),
              duration: 8000,
              type: 'is-success'
            })
            this.$router.push('/')
          })
          .catch((error) => {
            this.errors = error.response.data
          })
          .finally(() => {
            this.submitting = false
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .login {
    height: 80vh;
  }

  .button {
    margin-top: 20px;
    margin-bottom: 20px;
    min-width: 150px;
  }

  .login-logo {
    margin: 0 2rem 5rem;
    max-height: 100px;
  }

  .is-danger {
    color: #e01a1a;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue